import {useFindAllCategories} from "hooks/queries/category.query"
import {Category} from "dto/category/category"
import {Dispatch, SetStateAction, useEffect, useState} from "react"
import {RealDevice} from "dto/realdevice/devices"
import {UseFormSetValue} from "react-hook-form/dist/types/form"
import dayjs from "dayjs";

export function useRealDeviceForm() {

}

export function useCategories() {
    const [selectedParentCategoryId, setSelectedParentCategoryId] = useState<number | undefined | null>()
    const categories = useFindAllCategories()?.data
    const [parentCategories, setParentCategories] = useState<Category[]>([])
    const [childrenCategories, setChildrenCategories] = useState<Category[]>([])
    useEffect(() => {
        setParentCategories(categories?.filter((category: Category) => (category.level === "CITY")) || [])
    }, [categories])

    useEffect(() => {
        setChildrenCategories(categories?.filter((category: Category) => (category.parentId === selectedParentCategoryId)) || [])
    }, [categories, selectedParentCategoryId])

    return {
        categories,
        parentCategories,
        childrenCategories,
        selectedParentCategoryId,
        setSelectedParentCategoryId
    }
}

export function useInitDefaultFormValues(
    device: RealDevice | undefined,
    parentCategories: any, childrenCategories: any,
    setValue: UseFormSetValue<any>,
    setTitle: Dispatch<SetStateAction<string>>,
    setEditMode: Dispatch<SetStateAction<boolean>>,
    setSelectedParentCategoryId: Dispatch<SetStateAction<number | undefined | null>>,
    setDate: Dispatch<SetStateAction<Date | undefined>>,
) {
    useEffect(() => {
        if (device) {
            console.log("device: ", device)
            setValue("id", device.id)
            setValue("deviceEui", device?.communicationDevice.eui)
            setValue("serialNumber", device?.serialNumber)
            setValue("name", device?.name)
            setValue("address", device?.address.address)
            setValue("subAddress", device?.address.subAddress || "")
            setValue("mobile", device?.mobile?.phoneNumber || "")
            setValue("etc", device?.etc || "")
            setValue("remoteImgFiles", device.imageFiles || [])
            setValue("serialNumber", device.serialNumber)
            setValue("ignoreExternalEmission", device.ignoreExternalEmission)
            setValue("categoryId", device.category?.id)
            setTitle("휠체어(단말기) 수정하기")
            setSelectedParentCategoryId(device.category?.parentId)
            // setFileResource(device?.imageFile)
            setEditMode(true)
            setValue('protectorName', device?.protector?.name)
            setValue('protectorMobile', device?.protector?.mobile)
            setValue('secondaryProtectorName', device?.secondaryProtector?.name)
            setValue('secondaryProtectorMobile', device?.secondaryProtector?.mobile)
            setValue('installationDate', device?.installationDate ? device?.installationDate: undefined)
            if (device?.installationDate) {
                setDate((typeof device.installationDate === 'string') ? new Date(device.installationDate) : device.installationDate)
            }
        }
    }, [device, setValue, parentCategories])

    useEffect(() => {
        setValue("categoryId", device?.category?.id)
    }, [device, setValue, childrenCategories])
}